
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { createCandidateLoginFlow, verifyCandidateOtpFlow } from '../../../services/jobAuthService';
import { ApiError, CandidateResponse, CandidateState, createCandidatePayload } from './JobAuthTypes';

// create teams 
export const createCandidateLogin = createAsyncThunk<CandidateResponse, { payload: createCandidatePayload; },
  { rejectValue: string }
>(
  'base/createCandidateLogin',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await createCandidateLoginFlow(payload);
      return response;
    } catch (err) {
      const error = err as ApiError;      
      return rejectWithValue(error.response?.data?.message || 'Failed to login');
    }
  }
);

// verifyCandidateOtpFlow
export const verifyCandidateOtp = createAsyncThunk<CandidateResponse, { payload: createCandidatePayload; },
  { rejectValue: string }
>(
  'base/verifyCandidateOtp',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await verifyCandidateOtpFlow(payload);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to otp verify');
    }
  }
);

const initialState: CandidateState = {
  createCandidateStatus: 'idle',
  createCandidateError: null,
  createCandidateData: null,
  verifyCandidateStatus: 'idle',
  verifyCandidateError: null,
  verifyCandidateData: null
};

const JobAuthSlice = createSlice({
  name: 'jobauth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCandidateLogin.pending, (state) => {
        state.createCandidateStatus = 'loading';
      })
      .addCase(createCandidateLogin.fulfilled, (state, action: PayloadAction<CandidateResponse>) => {
        state.createCandidateStatus = 'succeeded';
        state.createCandidateData = action.payload;
      })
      .addCase(createCandidateLogin.rejected, (state, action) => {
        state.createCandidateStatus = 'failed';
        state.createCandidateError = action.payload || 'Failed to invite member';
      })
      .addCase(verifyCandidateOtp.pending, (state) => {
        state.verifyCandidateStatus = 'loading';
      })
      .addCase(verifyCandidateOtp.fulfilled, (state, action: PayloadAction<CandidateResponse>) => {
        state.verifyCandidateStatus = 'succeeded';
        state.verifyCandidateData = action.payload;
      })
      .addCase(verifyCandidateOtp.rejected, (state, action) => {
        state.verifyCandidateStatus = 'failed';
        state.verifyCandidateError = action.payload || 'Failed to invite member';
      });
  }
});

export default JobAuthSlice.reducer;

